/**
 * A small utility that takes a HTML string and parse it to clean it.
 * If the HTML string misses some closing tags, it will take care of it.
 * For now it only closes the br tags, but we could add more clean up features in the future
 *
 * @param HTMLString The HTML string to clean
 * @returns The cleaned HTML string
 */
export const cleanHtmlString = (HTMLString: string) => {
    const selectBRTagRegex = /<br>/g;

    return HTMLString.replace(selectBRTagRegex, '<br/>');
};
